<div class="toast" [ngStyle]="style" [ngClass]="$safeNavigationMigration(options?.type)">
    <app-button
        (click)="toaster.close()"
        aria-label="Close"
        cssClass="ghost transparent btn-x-sm"
        icon="Close"
        class="close-btn"
    >
    </app-button>
    <span class="title">{{ title }}</span>
    <p class="message">{{ message }}</p>
</div>
